module.exports = __webpack_public_path__ + "static/media/cupcakeStrawberry.f23c5af4.jpg";